"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 6a6 6 0 100 12 6 6 0 000-12zm1.819 8.163h-.69v-2.894l-.95 1.551h-.458l-.957-1.551v2.894h-.689v-4.16h.69l1.194 1.943 1.195-1.943h.665v4.16z" }), "Mods");
//# sourceMappingURL=Mods.js.map